import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const roles = {
  getRoles: async () => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get('/roles', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default roles;
